import * as Yup from 'yup';
import { INVALID_FIELDS, YupString, YupStringWithoutRequired } from './general';

export const fmtProductSchema = Yup.object().shape({
  noOfBottleAliquot: Yup.number()
    .positive(INVALID_FIELDS.POSITIVE_NUMBER)
    .integer(INVALID_FIELDS.INTEGER_NUMBER)
    .required(INVALID_FIELDS.REQUIRED),
  number: YupString,
  productId: YupString,
  giTest: Yup.string().oneOf(['PASS', 'FAILED']),
  oldFmtPrep: YupStringWithoutRequired,
  stoolBristolScore: YupStringWithoutRequired,
});

export const updateStockSchema = Yup.object().shape({
  productId: YupString,
});
